import React from 'react';
import CreateNonPayableBenefits from './CreateNonPayableBenefitsForm';
import { FormProvider } from 'forms';

const CreateNonPayableBenefitsView = () => {
  return (
    <FormProvider>
      <CreateNonPayableBenefits />
    </FormProvider>
  );
};

export default CreateNonPayableBenefitsView;
